import { Component, OnInit } from '@angular/core';
import { StorageService } from '../storage.service';
import { TimeService } from '../time.service';
import { Location } from '@angular/common';
import { HttpService } from '../http.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-invoice-preview',
  templateUrl: './invoice-preview.component.html',
  styleUrls: ['./invoice-preview.component.scss']
})
export class InvoicePreviewComponent implements OnInit {

  invoice_data:any = {}
  terms_conditions = '';
  span;
  logo;
  country;
  distance;

  other_charges:any = {};
  deductible_charges:any = {};
  addtionalCharges = [];
  showDeductibleCharges;
  currencySymbol;
  gst;
  show_distance = false;
  show_weight = false;
  show_package = false;
  show_cbm = false;
  constructor(private _location: Location,private http:HttpService,private storage:StorageService,public timeService:TimeService) { 
    this.country = environment.country;
  }

  ngOnInit() {

    const currency = JSON.parse(localStorage.getItem('carriers'));
    this.currencySymbol = currency[0].country.currency.symbol;
    this.invoice_data = JSON.parse(this.storage.getFromLocalStorage('Invoice'));

    if(this.invoice_data.rate_type == 'weight' || this.invoice_data.rate_sub_type == 'weight'){
      this.show_weight = true;
    }else if(this.invoice_data.rate_type == 'package' || this.invoice_data.rate_sub_type == 'package'){
      this.show_package = true;
    }else if(this.invoice_data.rate_type == 'cbm' || this.invoice_data.rate_sub_type == 'cbm'){
      this.show_cbm = true;
    }else{
      this.show_distance = true;
    }

    if(this.invoice_data.shipment){
      this.distance = this.invoice_data.shipment.estimated ? Math.round(this.invoice_data.shipment.estimated.distance/1000) : ''
    }else{
      this.distance = 'N/A'
    }
    let additional_charges = this.invoice_data.additional_charges;
    this.other_charges.labour = additional_charges.labour ? additional_charges.labour.value :'' ;
    this.other_charges.labour_comment = additional_charges.labour ? additional_charges.labour.comment :'' ;
    this.other_charges.cancellation = additional_charges.cancellation ? additional_charges.cancellation.value :'';
    this.other_charges.cancellation_comment = additional_charges.cancellation ? additional_charges.cancellation.comment :'';
    this.other_charges.extra_delivery = additional_charges.extra_delivery ? additional_charges.extra_delivery.value  : '';
    this.other_charges.extra_delivery_comment = additional_charges.extra_delivery ? additional_charges.extra_delivery.comment  : '';
    this.other_charges.extra_pickup = additional_charges.extra_pickup ? additional_charges.extra_pickup.value  : '';
    this.other_charges.extra_pickup_comment = additional_charges.extra_pickup ? additional_charges.extra_pickup.comment  : '';
    this.other_charges.insurance = additional_charges.insurance ? additional_charges.insurance.value  : '';
    this.other_charges.insurance_comment = additional_charges.insurance ? additional_charges.insurance.comment  : '';
    this.other_charges.non_hometown_halt = additional_charges.non_hometown_halt ? additional_charges.non_hometown_halt.value  : '';
    this.other_charges.non_hometown_halt_comment = additional_charges.non_hometown_halt ? additional_charges.non_hometown_halt.comment  : '';
    this.other_charges.toll = additional_charges.toll ? additional_charges.toll.value  : '';
    this.other_charges.toll_comment = additional_charges.toll ? additional_charges.toll.comment  : '';
    this.other_charges.doc = additional_charges.doc ? additional_charges.doc.value  : '';
    this.other_charges.doc_comment = additional_charges.doc ? additional_charges.doc.comment  : '';
    this.other_charges.LR_charges = additional_charges.LR_charges ? additional_charges.LR_charges.value  : '';
    this.other_charges.LR_charges_comment = additional_charges.LR_charges ? additional_charges.LR_charges.comment  : '';
    this.other_charges.detention = additional_charges.detention ? additional_charges.detention.value  : '';
    this.other_charges.detention_comment = additional_charges.detention ? additional_charges.detention.comment  : '';
    this.other_charges.detentionCustomer = additional_charges.detentionCustomer ? additional_charges.detentionCustomer.value  : '';
    this.other_charges.detention_customer_comment = additional_charges.detentionCustomer ? additional_charges.detentionCustomer.comment  : '';
    this.other_charges.detentionPlant = additional_charges.detentionPlant ? additional_charges.detentionPlant.value  : '';
    this.other_charges.detention_plant_comment = additional_charges.detentionPlant ? additional_charges.detentionPlant.comment  : '';
    this.other_charges.others = additional_charges.others ? additional_charges.others.value  : '';
    this.other_charges.others_comment = additional_charges.others ? additional_charges.others.comment  : '';
    this.other_charges.green_tax = additional_charges.green_tax ? additional_charges.green_tax.value : '';
    this.other_charges.green_tax_comment = additional_charges.green_tax ? additional_charges.green_tax .comment : '';

    let deductibleCharges = this.invoice_data.deductible_charges;

    this.showDeductibleCharges = (deductibleCharges.material_damage.value || deductibleCharges.material_missing.value || deductibleCharges.vehicle_delay.value || deductibleCharges.carton_damage.value || deductibleCharges.others.value)
    this.deductible_charges.material_damage = deductibleCharges.material_damage ? deductibleCharges.material_damage.value : 0;
    this.deductible_charges.material_damage_comment = deductibleCharges.material_damage ? deductibleCharges.material_damage.comment : '';
    this.deductible_charges.material_missing = deductibleCharges.material_missing ? deductibleCharges.material_missing.value : 0;
    this.deductible_charges.material_missing_comment = deductibleCharges.material_missing ? deductibleCharges.material_missing.comment : '';
    this.deductible_charges.vehicle_delay = deductibleCharges.vehicle_delay ? deductibleCharges.vehicle_delay.value : 0;
    this.deductible_charges.vehicle_delay_comment = deductibleCharges.vehicle_delay ? deductibleCharges.vehicle_delay.comment : '';
    this.deductible_charges.carton_damage = deductibleCharges.carton_damage ? deductibleCharges.carton_damage.value : 0;
    this.deductible_charges.carton_damage_comment = deductibleCharges.carton_damage ? deductibleCharges.carton_damage.comment : '';
    this.deductible_charges.others = deductibleCharges.others ? deductibleCharges.others.value : 0;
    this.deductible_charges.others_comment = deductibleCharges.others ? deductibleCharges.others.comment : '';

    this.terms_conditions = this.invoice_data.terms_conditions;
    this.logo = this.invoice_data.logo || '';

    if(this.country == 'IN'){
      if(this.invoice_data.tax_type == 'FCM12'){
        if(this.invoice_data.transit_type == 'INTRA'){
          this.gst = environment.FCM12_GST;
        }else{
          this.gst = environment.FCM12_GST;
        }
      } else if (this.invoice_data.tax_type == 'FCM18'){
        if(this.invoice_data.transit_type == 'INTRA'){
          this.gst = environment.FCM18_GST;
        }else{
          this.gst = environment.FCM18_GST;
        }
      }
      else if(this.invoice_data.tax_type == 'RCM'){
        if(this.invoice_data.transit_type == 'INTRA'){
          this.gst = environment.RCM_GST;
        }else{
          this.gst = environment.RCM_GST;
        }
      }
    }else{
      this.gst = environment.FCM12_GST;
    }


    if(this.invoice_data.tax_type == 'RCM' && this.country == 'IN'){
      this.span = 6
    }else{
      this.span = 5
    }
  }

  ngOnDestroy(){
    this.storage.clearFromLocalStorage('Invoice');
  }
  backClicked(){
   this._location.back();
  }

}
